import { SearchOutlined } from "@ant-design/icons";
import { Button, Input, Select, DatePicker } from "antd";
import { CSSProperties, useCallback, useEffect, useState } from "react";
export type SearchType = "Enter" | "Delay" | "OnChange";
const SearchBar = ({
  onChange,
  searchType = "OnChange",
  value,
  style,
  placeholder = "Search ...",
  searchFields,
  showDateFilter = false
}: {
  searchType: SearchType;
  onChange: (value: ISearchQuery) => void;
  style?: CSSProperties;
  value?: string;
  placeholder?: string;
  searchFields?: string[],
  showDateFilter?: boolean
}) => {
  const [sValue, setSValue] = useState<any>(value);
  const [selectedFields, setSelectedFields] = useState([]);
  const [dateValue, setDateValue] = useState<any>();
  const getWidth = useCallback(() => {
    // default is 100 for button
    let width = 100;
    if (showDateFilter === true) {
      width += 250;
    }
    if (searchFields && searchFields?.length > 0) {
      width += 100;
    }
    return width;
  }, [showDateFilter, searchFields]);

  useEffect(() => {
    if (!sValue) {
      onChange({ q: "", selectedFields, date: dateValue });
    }
    switch (searchType) {
      case "Delay":
        if (sValue?.length > 0) {
          const delay = setTimeout(() => onChange({ q: sValue, selectedFields, date: dateValue }), 800);
          return () => {
            clearTimeout(delay);
          };
        } else {
          onChange({ q: "", selectedFields, date: dateValue });
        }
        break;
      case "Enter":
        break;
      case "OnChange":
        onChange({ q: sValue, selectedFields, date: dateValue });
        break;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- onChange from parent; syncing from value/sValue only
  }, [value, sValue]);

  return (
    <div style={style}>
      <Input.Group compact>
        <Input
          onChange={(e) => {
            setSValue(e.target.value);
          }}
          value={sValue}
          onKeyDown={(e) => {
            if (searchType === "Enter" && e.key === "Enter") {
              const trimmed = sValue?.trim?.() ?? "";
              if (trimmed.length > 0) {
                onChange({ q: trimmed, selectedFields, date: dateValue });
              }
            }
          }}
          placeholder={placeholder}
          style={{ width: `calc(100% - ${getWidth()}px)` }}
          prefix={<SearchOutlined />}
        />
        {
          showDateFilter === true &&
          <DatePicker.RangePicker format="YYYY/MM/DD" style={{ width: 250 }} onChange={(val) => setDateValue(val)} />
        }
        {
          searchFields && searchFields.length > 0 &&
          <Select maxTagCount="responsive" placeholder="filter fields" style={{ width: 100 }} mode="multiple" value={selectedFields} onChange={(val) => {
            setSelectedFields(val);
          }} options={searchFields?.map((e) => ({ value: e, label: e }))} />
        }
        <Button onClick={() => {
          onChange({ q: sValue ?? "", selectedFields, date: dateValue })
        }
        }
          style={{ width: 100 }}>
          Search
        </Button>
      </Input.Group>
    </div>
  );
};

export interface ISearchQuery {
  q: string,
  selectedFields?: string[],
  date?: any
}
export default SearchBar;

